import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { BUSINESS, SERVICES, CITIES } from "@/data/site";
import { trackEvent } from "@/lib/api";
import { WaveTop } from "@/components/Decor";

export default function Footer() {
  return (
    <footer className="mt-24" data-testid="site-footer">
      <WaveTop color="#1E293B" />
      <div className="bg-espresso text-parchment/80">
        <div className="container-mbf py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img src="/logo-white.svg" alt="Mom's Best Friend Sitters" className="h-20 w-auto mb-4" />
            <p className="text-sm leading-relaxed text-parchment/70 mb-5">DFW's most-loved premium sitter agency. 11-step screened, CPR-certified caregivers for over 30 joyful years.</p>
            <div className="flex gap-3">
              {[["facebook", Facebook], ["instagram", Instagram]].map(([key, Icon]) => (
                <a key={key} href={BUSINESS.social[key]} target="_blank" rel="noreferrer" aria-label={key} className="w-10 h-10 rounded-full bg-parchment/10 flex items-center justify-center hover:bg-coral transition-colors" data-testid={`footer-${key}-link`}>
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.map((s) => (
                <li key={s.id}><Link to={`/services/${s.id}`} className="hover:text-gold transition-colors" data-testid={`footer-service-${s.id}`}>{s.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Service Areas</h4>
            <ul className="space-y-2.5 text-sm">
              {CITIES.map((c) => (
                <li key={c.id}><Link to={`/service-areas/${c.id}`} className="hover:text-gold transition-colors" data-testid={`footer-city-${c.id}`}>{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li><a href={BUSINESS.phoneHref} onClick={() => trackEvent("call_click", { source: "footer" })} className="flex items-start gap-2.5 hover:text-gold transition-colors" data-testid="footer-phone-link"><Phone className="w-4 h-4 mt-0.5 shrink-0" /> {BUSINESS.phone}</a></li>
              <li><a href={`mailto:${BUSINESS.email}`} className="flex items-start gap-2.5 hover:text-gold transition-colors break-all" data-testid="footer-email-link"><Mail className="w-4 h-4 mt-0.5 shrink-0" /> {BUSINESS.email}</a></li>
              <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> {BUSINESS.address}</li>
            </ul>
            <div className="mt-5 flex flex-col gap-2">
              <Link to="/book" className="btn-accent w-full !py-2.5" data-testid="footer-request-cta">Request a Sitter</Link>
              <Link to="/careers" className="text-sm text-parchment/70 hover:text-gold transition-colors mt-1" data-testid="footer-apply-link">Careers · Become a Sitter →</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-parchment/15">
          <div className="container-mbf py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-parchment/60">
            <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
            <p data-testid="footer-credit">
              Designed by{" "}
              <a href="https://mozeid.com/" target="_blank" rel="noreferrer" className="font-bold text-gold hover:text-white transition-colors" data-testid="footer-mostudio-link">Mo Studio</a>
            </p>
            <div className="flex items-center gap-5">
              <Link to="/careers" className="hover:text-gold transition-colors" data-testid="footer-careers-link">Careers</Link>
              <Link to="/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy-link">Privacy</Link>
              <Link to="/terms" className="hover:text-gold transition-colors" data-testid="footer-terms-link">Terms</Link>
              <Link to="/accessibility" className="hover:text-gold transition-colors" data-testid="footer-accessibility-link">Accessibility</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
